export default __webpack_public_path__ + "static/newsletter-background-img-5f0219d0a1b6bcd91448b1feca2eb9b7.svg";